import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';

import Env from 'lib/Env';
import { openSessionTimeoutModal } from '../hub/actions/modalSystemActions';

const TIMER_INTERVAL = 3300000; // 55 minutes
const THROTTLE_LIMIT = 1000; // 1 second
const ACTIVITY_EVENTS = ['mousemove', 'keydown', 'touchstart']; // activity indicators: mouse, keyboard, touch

const getTimerInterval = () => {
  if (Env.isDevEnv && AQUA_GLOBALS.QA?.sessionTimeoutIntervalMs) {
    return AQUA_GLOBALS.QA.sessionTimeoutIntervalMs;
  }
  return TIMER_INTERVAL;
};

const SessionTimeout = () => {
  const dispatch = useDispatch();
  const timeoutRef = useRef(null);
  const lastActivityRef = useRef(Date.now());

  useEffect(() => {
    // Logout modal timer starts on mount and resets on activity event detection
    const resetTimeout = () => {
      // Prevent excessive timer operations during continuous mouse movement
      // Improved performance mostly for older devices
      const currentTime = Date.now();
      if (currentTime - lastActivityRef.current > THROTTLE_LIMIT) {
        lastActivityRef.current = currentTime;

        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current);
        }

        timeoutRef.current = setTimeout(() => {
          dispatch(openSessionTimeoutModal());
        }, getTimerInterval());
      }
    };

    // Set initial logout modal timer
    resetTimeout();

    ACTIVITY_EVENTS.forEach(event => {
      document.addEventListener(event, resetTimeout, { passive: true });
    });

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      ACTIVITY_EVENTS.forEach(event => {
        document.removeEventListener(event, resetTimeout, { passive: true });
      });
    };
  }, [dispatch]);

  return null;
};

export default SessionTimeout;
